var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._v(" 首页 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }